// extracted by mini-css-extract-plugin
export var label = "_hq-0";
export var treatmentCard = "_hq-1";